import React, { Component } from 'react';
import sizeMe from 'react-sizeme';
import userDefaultIcon from '../../assets/user-default-icon.png';
import DeviceHelper from '../../functions/device';

// import Logger from '../../functions/logging';

const sizeMeConfig = {
	monitorWidth: true,
	monitorHeight: false, // ❗️ Note set to `false` by default
	refreshRate: 16,
	refreshMode: 'throttle',
	noPlaceholder: false,
};

class carouselContainer extends Component {

	componentDidMount() {
		const { width } = this.props.size;
		this.handleSizeUpdate(width);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.size.width !== nextProps.size.width) {
			this.handleSizeUpdate(nextProps.size.width);
		}
	}

	handleSizeUpdate = width => {
		const carouselItemWidth = (DeviceHelper.isMobile && !DeviceHelper.isTablet) ? 270 : 470;
		const offset = (width / 2) - (carouselItemWidth / 2);
		this.props.updateCarouselItemOffset(offset);
	}

	render() {
		const landingSlider = 'landingSlider';
		return (
			<ul ref={landingSlider} style={{ transform: this.props.translate, transition: 'transform ease-out 0.45s' }} className='landing-slider'>
				{this.props.content.map((item, index) => {

					return <li key={item.id} className='landing-carousel-item'>
						<div className='pc-quote-container'>
							<p className='pc-quote-text'>&quot;{item.quote}&quot;</p>
						</div>

						<div className='pc-quote-name-container'>
							<img src={userDefaultIcon} alt='User Icon' className='pc-user-image' />
							<h4 className='pc-name-text'>{item.name}</h4>
						</div>
					</li>;
				})}
			</ul>
		);
	}
}

const CarouselContainer = sizeMe(sizeMeConfig)(carouselContainer);

class PilotlyCarousel extends Component {

	constructor(props) {
		super(props);

		this.state = {
			content: props.content,
			activeIndicator: 0,
			carouselItemOffset: 0 //(DeviceHelper.isMobile && !DeviceHelper.isTablet) ? 270 : 470 * Object.keys(viewerContent).length + 60 
		};
	}

	handleClick = index => {
		const { content, activeIndicator } = this.state;
		const newContent = [...content];
		newContent[activeIndicator].active = false; // mark old indicator as inactive
		newContent[index].active = true; // mark new indicator as active
		const newCarouselItemOffset = this.newCarouselItemOffset(activeIndicator, index);

		this.setState({ content: newContent, activeIndicator: index, carouselItemOffset: newCarouselItemOffset }); //set the new array
	}

	updateCarouselItemOffset = carouselItemOffset => this.setState({ carouselItemOffset });
	
	newCarouselItemOffset = (oldIndex, newIndex) => {
		const { carouselItemOffset } = this.state;
		const paddingOffeset = 40;
		const isMobileOnly = DeviceHelper.isMobile && !DeviceHelper.isTablet;
		const cardSize = isMobileOnly ? 270 : 470;
		const staticOffset = paddingOffeset + cardSize;

		if (oldIndex === newIndex) return carouselItemOffset;

		if (newIndex === 0) {
			return isMobileOnly ? 35 : 314.75;
		}

		// Logger.log('these are the old index', oldIndex, 'these are the new index', newIndex);

		if (oldIndex > newIndex) {
			let amountToRemove = (oldIndex - newIndex);
			// GOES FORWARD
			return (carouselItemOffset + (amountToRemove * staticOffset));
		}
		let amountToRemove = newIndex - oldIndex;
		// GOES BACKWARD
		return (carouselItemOffset - (amountToRemove * staticOffset));
	}

	render() {

		const { content, carouselItemOffset } = this.state;
		const translate = 'translate3d(' + carouselItemOffset + 'px, 0px, 0px) ';
		// const { width, height } = this.props.size;

		return (
			<div className='pilotly-carousel-container'>
				<div className='pilotly-carousel'>

					<CarouselContainer updateCarouselItemOffset={this.updateCarouselItemOffset} content={content} translate={translate} />

					<div className='landing-controls-flex-container'>
						<ul className='landing-controls'>
							{this.props.content.map((item, index) => {
								return <li key={item._id} onClick={this.handleClick.bind(null, index, index)} className={`landing-carousel-indicator ${item.active ? 'active-landing-indicator' : ''}`}></li>;
							})}
						</ul> 
					</div>
				</div>
			</div>
		);
	}
}

export default sizeMe(sizeMeConfig)(PilotlyCarousel);


// WEBPACK FOOTER //
// ./src/components/global/PilotlyCarousel.js